import _extends from "@babel/runtime/helpers/esm/extends";
import { EModel } from './model';
import { fieldsUser } from './user';
export let EProviderSource;
(function (EProviderSource) {
  EProviderSource["Upload"] = "upload";
  EProviderSource["PatientReferralForm"] = "patient-referral-form";
  EProviderSource["Ui"] = "ui";
  EProviderSource["Integrator"] = "integrator";
})(EProviderSource || (EProviderSource = {}));
export let EProviderBillingType;
(function (EProviderBillingType) {
  EProviderBillingType["Resource"] = "resource";
  EProviderBillingType["PartTime"] = "part-time";
  EProviderBillingType["FullTime"] = "full-time";
  EProviderBillingType["NonBilled"] = "non-billed";
  EProviderBillingType["Duplicate"] = "duplicate";
  EProviderBillingType["NoLongerEmployed"] = "no-longer-employed";
  EProviderBillingType["Unknown"] = "unknown";
})(EProviderBillingType || (EProviderBillingType = {}));
export let EZoomUserStatus;
(function (EZoomUserStatus) {
  EZoomUserStatus["Active"] = "active";
  EZoomUserStatus["Inactive"] = "inactive";
  EZoomUserStatus["Pending"] = "pending";
})(EZoomUserStatus || (EZoomUserStatus = {}));
export const fieldsProvider = _extends({}, fieldsUser, {
  alternativeName: {
    type: 'Text'
  },
  billingType: {
    type: 'Option',
    values: EProviderBillingType
  },
  biography: {
    type: 'Text'
  },
  biographyUrl: {
    type: 'Text'
  },
  deptCode: {
    type: 'Text'
  },
  externalRawSource: {
    type: 'Unknown'
  },
  headshot: {
    type: 'ID',
    ref: EModel.FileUpload
  },
  impersonate: {
    type: 'Object',
    array: true
  },
  isReferringProvider: {
    type: 'Boolean'
  },
  isRenderingProvider: {
    type: 'Boolean'
  },
  mergedInto: {
    type: 'ID',
    ref: EModel.Provider
  },
  npi: {
    type: 'Number'
  },
  phonetic: {
    type: 'Text'
  },
  schedulable: {
    type: 'Boolean'
  },
  source: {
    type: 'Option',
    values: EProviderSource
  },
  specialInstructions: {
    type: 'Text'
  },
  telehealthVendors: {
    type: 'Object'
  },
  visible: {
    type: 'Boolean'
  }
});